import { useCallback, useMemo } from 'react';
import { IBatchResponse } from '../models';
import { APITelemetry, ILogEntry } from '../Telemetry';

interface IReturnProps {
  readonly startTelemetryReport: (payload: ILogEntry) => void;
  readonly stopTelemetryReport: (status: Status, payload: unknown) => void;
  readonly startBatchTelemetryReport: (payload: { id: string }[]) => void;
  readonly stopBatchTelemetryReport: (id: string, result: IBatchResponse<any>) => void;
}

type Status = 'success' | 'error';

export const useReportAPITelemetry = (name: string): IReturnProps => {
  const apiTelemetry: APITelemetry = useMemo(() => new APITelemetry(), []);

  const start = useCallback(
    (payload: ILogEntry) => {
      apiTelemetry.startActivity(name, payload);
    },
    [apiTelemetry, name],
  );

  const stop = useCallback(
    (status: Status, payload: unknown) => {
      if (status === 'error') {
        apiTelemetry.stopActivity(name, { result: -1, payload });
      } else {
        apiTelemetry.stopActivity(name, { result: 0, payload });
      }
    },
    [apiTelemetry, name],
  );

  const startBatch = useCallback(
    (payload: { id: string }[]) => {
      apiTelemetry.startBatchActivity(name, payload);
    },
    [apiTelemetry, name],
  );

  const stopBatch = useCallback(
    (id: string, result: IBatchResponse<any>) => {
      apiTelemetry.stopBatchActivity(name, id, result);
    },
    [apiTelemetry, name],
  );

  return {
    startTelemetryReport: start,
    stopTelemetryReport: stop,
    startBatchTelemetryReport: startBatch,
    stopBatchTelemetryReport: stopBatch,
  };
};
